/**
 * Whether the home health demo presenter layer is active in this browser.
 *
 * The `demo` branch serves several demo tenants; this layer only shows itself
 * for the organization the seed builds (`ORG_NAME`, matched exactly, so an old
 * tenant renamed to "Home Health Demo (old)" stays off) or when explicitly
 * switched on for this browser (`?homeHealthDemo=1` or the presenter drawer).
 * Nothing else on the branch is affected when it is off.
 */
import { ORG_NAME } from "@caredna-marlin/utils/homeHealthDemo/seed/sql";
import { ENABLED_KEY, safeLocalStorage } from "./store/persistence";

export function isHomeHealthDemoEnabled(organizationName?: string, storage: Storage | undefined = safeLocalStorage()): boolean {
  try {
    const flag = storage?.getItem(ENABLED_KEY);
    if (flag === "1") return true;
    if (flag === "0") return false;
  } catch {
    // fall through to the organization rule
  }
  return organizationName === ORG_NAME;
}

export function setHomeHealthDemoEnabled(enabled: boolean, storage: Storage | undefined = safeLocalStorage()): void {
  try {
    storage?.setItem(ENABLED_KEY, enabled ? "1" : "0");
  } catch {
    // ignore
  }
}

/** Query-string override: `?homeHealthDemo=1` enables, `?homeHealthDemo=0` disables. Returns true if it changed anything. */
export function applyQueryOverride(search: string, storage: Storage | undefined = safeLocalStorage()): boolean {
  const value = new URLSearchParams(search).get("homeHealthDemo");
  if (value === "1" || value === "0") {
    setHomeHealthDemoEnabled(value === "1", storage);
    return true;
  }
  return false;
}
